import {defineStore} from "pinia";

export const useWorkFlowStore = defineStore('validationWorkFlowWorkFlow', {
    state: () => ({
        workFlow: {},
        workFlows: [],
    }),
    actions: {
        setWorkFlow(workFlow) {
            this.workFlow = workFlow
        },
        setWorkFlows(workFlows) {
            this.workFlows = workFlows
        },
        addWorkFlow(workFlow) {
            this.workFlows.unshift(workFlow)
        },
        updateWorkFlow(workFlow) {
            let index = this.workFlows.findIndex(cl => cl.id === workFlow.id)
            this.workFlows.splice(index, 1, workFlow)
        },
        deleteWorkFlow(workFlow) {
            let index = this.workFlows.findIndex(cl => cl.id === workFlow.id)
            this.workFlows.splice(index, 1)
        },
    },
});